module.exports = __webpack_public_path__ + "static/media/guestRequest.b9b77383.svg";